/**
 * The design system's compact menu register, for menus the shared dropdown primitive is not
 * tuned for (it serves the app's older menus: 12px text, accent highlight, 16px icons). A row is
 * 32px, 14px sans, the n-05 wash on hover and highlight, 14px glyphs; the panel is the popover
 * ground with a hairline and elev-3. The rail's account quick-nav and the footer's model menu
 * share these so they read as one family.
 */
export const DS_MENU_ITEM_CLASS =
  // Row register borrowed from the left rail so the highlight reads the same
  // on both surfaces — same n-05 fill, same rounded-md pill.
  "min-h-8 cursor-pointer select-none rounded-md py-0 text-base text-n-80 hover:bg-n-05 hover:text-n-80 focus:bg-n-05 focus:text-n-80 data-[highlighted]:bg-n-05 [&_svg]:size-3.5";

export const DS_MENU_SEPARATOR_CLASS = "mx-0 bg-n-10";

export const DS_MENU_CONTENT_CLASS =
  "border-n-10 bg-popover shadow-[var(--elev-3)]";
